import React from "react";
import { Trash2, Leaf, Wrench, ArrowUpRight } from "lucide-react";
import { useLang } from "../LangContext";
import { IMAGES } from "../constants";

const ServiceCard = ({ icon: Icon, title, desc, image, testId, onClick }) => (
  <article
    data-testid={testId}
    className="group flex flex-col bg-white rounded-3xl overflow-hidden border border-[#7a8b50]/15 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-500 cursor-pointer"
    onClick={onClick}
  >
    <div className="relative h-56 overflow-hidden">
      <img
        src={image}
        alt={title}
        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#1e3a5f]/40 via-transparent to-transparent" />
      <div className="absolute top-5 left-5 h-12 w-12 rounded-full bg-white/95 flex items-center justify-center">
        <Icon className="h-5 w-5 text-[#7a8b50]" />
      </div>
    </div>
    <div className="p-7 flex flex-col gap-4 flex-1">
      <h3 className="font-serif-display text-2xl font-medium text-[#1e3a5f] leading-snug">{title}</h3>
      <p className="text-sm text-[#1e3a5f]/70 leading-relaxed flex-1">{desc}</p>
      <div className="pt-2 flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[#7a8b50] font-semibold">
        Reservar / Presupuesto
        <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </div>
    </div>
  </article>
);

export default function Services({ onScrollTo }) {
  const { t } = useLang();

  return (
    <section id="servicios" className="py-24 md:py-32" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-16">
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-10 bg-[#7a8b50]" />
            <span className="text-[11px] uppercase tracking-[0.28em] text-[#7a8b50] font-semibold">
              {t.smallLabels.services}
            </span>
          </div>
          <h2 className="font-serif-display text-4xl md:text-5xl text-[#1e3a5f] font-medium tracking-tight leading-tight">
            {t.services.title}
          </h2>
          <p className="mt-5 text-base text-[#1e3a5f]/70 leading-relaxed">{t.services.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-7">
          <ServiceCard
            testId="service-card-garbage"
            icon={Trash2}
            title={t.services.garbage.title}
            desc={t.services.garbage.desc}
            image={IMAGES.garbage}
            onClick={() => onScrollTo("reserva")}
          />
          <ServiceCard
            testId="service-card-gardening"
            icon={Leaf}
            title={t.services.gardening.title}
            desc={t.services.gardening.desc}
            image={IMAGES.gardening}
            onClick={() => onScrollTo("reserva")}
          />
          <ServiceCard
            testId="service-card-maintenance"
            icon={Wrench}
            title={t.services.maintenance.title}
            desc={t.services.maintenance.desc}
            image={IMAGES.maintenance}
            onClick={() => onScrollTo("reserva")}
          />
        </div>
      </div>
    </section>
  );
}
